import React, { Suspense, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getApi } from "../../../Services/apiService";
import Modal from 'react-modal';
import ReviewModal from "./reviewDetail";

import "bootstrap/dist/css/bootstrap.min.css";
import ImageSliderModal from "./imageSlider";
import ImagePreview from "./imagePreview";

const VenueDetail = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [venueDetails, setVenueDetails] = useState(null);
  const [selectedReview, setSelectedReview] = useState(null);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [imageFullOpen, setImageFullOpen] = useState(false);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toISOString().split("T")[0];
  };

  // const averageRating = (
  //   venueDetails?.Reviews?.reduce((sum, review) => sum + review.rating, 0) /
  //     venueDetails?.Reviews.length || 0
  // ).toFixed(1);

  const formatWebsiteUrl = (url) => {
    if (!url) return '';

    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return `http://${url}`;
    }

    return url;
  };

  const priceRangeMapping = {
    1: '$',
    2: '$$',
    3: '$$$',
    4: '$$$$',
    5: '$$$$$'
  };

  const handleImageClick = (index) => {
    setSelectedIndex(index);
    setIsSliderOpen(true);
  };

  const fetchVenueDetails = async () => {
    setLoading(true);

    try {
      const endpoint = `/admin/category-detail?category_id=${id}`;
      const response = await getApi(endpoint);

      if (response && response.status === 200) {
        setVenueDetails(response.data);
      } else {
        throw new Error("Failed to fetch venues.");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const closeSlider = () => {
    setIsSliderOpen(false);
  };

  const openReviewModal = () => {
    if (venueDetails?.Reviews?.length > 0) {
      setSelectedReview(venueDetails.Reviews);
      setIsReviewModalOpen(true);
    }
  };

  const closeReviewModal = () => {
    setIsReviewModalOpen(false);
    setSelectedReview(null);
  };

  const closeImageFull = () => {
    setImageFullOpen(false);
  };

  useEffect(() => {
    fetchVenueDetails();
  }, []);

  // Helper function to format the rating with half and full stars using images
  const formatRating = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const totalStars = 5;
    const stars = [];
  
    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <img
          key={`full-${i}`}
          src={window.getPublicUrl("assets/images/full-star.png")}
          alt="Full Star"
          className="star-icon"
        />
      );
    }
  
    // Half star
    if (hasHalfStar) {
      stars.push(
        <img
          key="half"
          src={window.getPublicUrl("assets/images/half-star.png")}
          alt="Half Star"
          className="star-icon"
        />
      );
    }

  
    return stars;
  };
  
  

  return (
    <div className="RightSideDiv banner-view">
      <div className="car-care-tips">
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="row">
              <div className="col-md-12"></div>
              <div className="col-md-6">
                <div className="left">
                  <div className="lef-banner">
                    <img
                      src={venueDetails?.banner_image}
                      alt={venueDetails?.name}
                      className=""
                      height={200}
                      width={200}
                      onClick={() => setImageFullOpen(true)}
                    />
                    {imageFullOpen && (
                      <div
                        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80"
                        onClick={() => setImageFullOpen()}
                      >
                        <img
                          src={venueDetails?.banner_image}
                          alt={venueDetails?.name}
                          className="max-w-full max-h-full"
                        />
                      </div>
                    )}
                  </div>

                  <div className="image-gallery">
                    <h1>Photos</h1>
                    {venueDetails?.Category_Images?.length &&
                      venueDetails?.Category_Images.map((img, index) => (
                        <img
                          key={img.id}
                          src={img.url}
                          alt="venueDetails"
                          className="thumbnail"
                          onClick={() => handleImageClick(index)}
                        />
                      ))}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="view-deatils-data">
                  <h3 className="heading">{venueDetails?.name}</h3>
                  <ul>
                    <li>
                      <h5>Short Description:</h5> <span>{venueDetails?.short_desc}</span>
                    </li>
                    {/* <li>
                      <h5>Latitude-Longitude:</h5>
                      {venueDetails?.latitude} - {venueDetails?.longitude}
                      <a
                        className="open-map"
                        href={`https://www.google.com/maps/search/?api=1&query=${venueDetails?.latitude},${venueDetails?.longitude}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open In Map
                      </a>
                    </li> */}
                    <li>
                      <h5>Location:</h5>  <span> <a
                        // className="open-map"
                        // href={`https://www.google.com/maps/search/?api=1&query=${venueDetails?.latitude},${venueDetails?.longitude}`}
                        href={`https://www.google.com/maps/place/?q=place_id:${venueDetails?.place_id}`} 
                        target="_blank"
                        rel="noopener noreferrer"
                      >{venueDetails?.location} </a></span>
                      {/* <a
                        className="open-map"
                        // href={`https://www.google.com/maps/search/?api=1&query=${venueDetails?.latitude},${venueDetails?.longitude}`}
                        href={`https://www.google.com/maps/place/?q=place_id:${venueDetails?.place_id}`} 
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open In Map
                      </a> */}
                    </li>
                    <li>
  <h5>Phone:</h5>
  <a href={`tel:${venueDetails?.phone_number}`} >
    {venueDetails?.phone_number}
  </a>
</li>
                    <li>
  <h5>Email:</h5>
  <a href={`mailto:${venueDetails?.email}`} className="email-link">
    {venueDetails?.email}
  </a>
</li>
                    <li>
                      <h5>Price Range:</h5>
                      <span>{priceRangeMapping[venueDetails?.price_range] || 'N/A'}</span>
                    </li>
                    <li>
                      <h5>Description:</h5>
                      <span>{venueDetails?.description}</span>
                    </li>
        
                    <li>
                      <h5>Website:</h5>
                      <span>
                        <a
                          href={formatWebsiteUrl(venueDetails?.website_link)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {venueDetails?.website_link}
                        </a>
                      </span>
                    </li>
                    <li>
  
  <h5>Types:</h5>
  <ul>
    {venueDetails?.Category_Types?.map((type, index) => (
      <li key={type.id}>
        {index + 1} {type.name}
      </li>
    ))}
  </ul>
</li>
<li>
 <h5>Average Rating:</h5>
        
<span>
 
 {venueDetails?.average_rating} 
    <img src={window.getPublicUrl("assets/images/full-star.png")} alt="star" />

  ({venueDetails?.Reviews?.length || 0} reviews)
</span>
                    </li>
                  </ul>
                </div>
                {venueDetails?.Reviews?.length > 0 && (
                  <li className="reviewli" key={venueDetails.Reviews[0].id}>
                    <h4 className="review-heading">Reviews</h4>
                    <div className="review-main">
                      <span>
                        <img
                          src={venueDetails.Reviews[0]?.User?.image || window.getPublicUrl("/assets/images/dummy-profile.jpg")}
                          alt="venueDetails"
                        />
                      </span>
                      <div className="review-name-main">
                        <p className="review-name">
                          {venueDetails.Reviews[0].User.name}
                        </p>
                        <p className="sur-name">{venueDetails.Reviews[0].User.user_name}</p>
                      </div>
                      <p className="review-text">
                        {venueDetails.Reviews[0].review_text}
                      </p>
                      <p className="star">
                      {venueDetails.Reviews[0].rating}  {formatRating(venueDetails.Reviews[0].rating)}
                      </p>
                      <p className="star date">
                        {formatDate(venueDetails.Reviews[0].date_of_experience)}
                      </p>
                      {venueDetails.Reviews.length > 1 && (
                        <div>
                          <button
                            className="read-more"
                            onClick={openReviewModal}
                          >
                            All Reviews
                          </button>
                        </div>
                      )}
                    </div>
                  </li>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      {/* Review Modal */}
      <Suspense fallback={<div>Loading...</div>}>
        <Modal
          isOpen={isReviewModalOpen}
          onRequestClose={closeReviewModal}
          contentLabel="Review Modal"
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName="modal-overlay review-modal"
          portalClassName="review-modal-xyz"
        >
          <ReviewModal isOpen={isReviewModalOpen} onClose={closeReviewModal} reviews={selectedReview} />
        </Modal>
      </Suspense>

      {/* Image Slider Modal */}
      <Suspense fallback={<div>Loading...</div>}>
        <Modal
          isOpen={isSliderOpen}
          onRequestClose={closeSlider}
          contentLabel="Image Slider Modal"
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName="modal-overlay review-modal"
          portalClassName="review-modal-portal"
        >
          <ImageSliderModal
            isOpen={isSliderOpen}
            onClose={closeSlider}
            selectedIndex={selectedIndex}
            images={venueDetails?.Category_Images}
          />
        </Modal>
      </Suspense>

      {/* Image Preview Modal */}
      <Suspense fallback={<div>Loading...</div>}>
        <Modal
          isOpen={imageFullOpen}
          onRequestClose={closeImageFull}
          contentLabel="Image Slider Modal"
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          overlayClassName="modal-overlay review-modal"
          portalClassName="review-modal-portal"
        >
          <ImagePreview
            isOpen={imageFullOpen}
            onClose={closeImageFull}
            images={venueDetails?.banner_image}
          />
        </Modal>
      </Suspense>
    </div>
  );
};

export default VenueDetail;